<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="color: black; background-color: #fff">
            <h6>{{title}}</h6>
            <div class="text-center">
                <h4 class="fix-margin">
                    {{accountingStatistics}}
                    <span style="font-size: 1.5rem">
                    {{' ' + $t('currency.rial')}}
                </span>
                </h4>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "statistics",
        props: {
            accountingStatistics: {
                default() {
                    return {}
                }
            },
            title: {
                default() {
                    return {}
                }
            }
        },

    }

</script>

<style>

</style>
